import { DocumentsComponent } from "@/features";
import { Deal } from "@/types";
import { useOutletContext } from "react-router-dom"

type ClientOutletContext = {
  deals: Deal[]
  isLoading: boolean
}

export const DocumentsPage = () => {
  const { deals, isLoading } = useOutletContext<ClientOutletContext>()
  return <DocumentsComponent deals={deals} isLoading={isLoading} />;
}